// ─────────────────────────────────────────────────────────────────────────────
// 🔑 AN UPLOAD THE SERVER IS STILL CHECKING (Jesse, 2026-11-04 — folded into the dashboard round 2; R1's finding,
// .scratch/reports/reliability-r1.md). When the virus scanner is unreachable and VIRUS_SCAN_ENFORCE is on, an upload is
// held and answered 202 UPLOAD_CHECKING ({ quarantined: true }, no documentId); the quarantine sweep stores it once the
// scanner is back (backend utils/uploadQuarantine). Every borrower screen used to treat any 2xx as "uploaded".
//   · isUploadChecking(res) — that answer, from an axios response ({ status, data }) or a fetch result ({ status, body }).
//   · The borrower's line for it on THESE screens is OFF until Hannah approves (UPLOAD_CHECKING_APPROVED). While off the
//     screen shows the slot as NOT YET UPLOADED (never "uploaded") and keeps submit disabled until the file lands.
//   · ⚠️ The line is the server's APPROVED sentence (backend constants/uploadScanCopy PUBLIC_CHECKING, Hannah 2026-11-02 —
//     sent in the 202 body's `message`), mirrored here, so one sentence is used everywhere (test/dashboardRound2 pins the
//     two). The round-2 request proposed "We’re checking this file. It will appear here in a minute." — not used.
// Pure — no imports — so backend tests load it.
// ─────────────────────────────────────────────────────────────────────────────
export const UPLOAD_CHECKING_APPROVED = true;   // 🔑 ON (Jesse, round 3, 2026-11-04)
export const UPLOAD_CHECKING_COPY = 'Thanks. We’re checking your file, and it will appear here in a few minutes.';
export const UPLOAD_CHECKING_CODE = 'UPLOAD_CHECKING';

/** Is this upload answer "held, still being checked"? */
export function isUploadChecking(res) {
  if (!res) return false;
  const body = res.data !== undefined ? res.data : res.body;
  return Number(res.status) === 202 && !!body && (body.quarantined === true || body.code === UPLOAD_CHECKING_CODE);
}

/** For a helper that must return a stored document: a held answer becomes this error (code UPLOAD_CHECKING), so a chained
 *  step (a letter, a condition answer, a gift) stops instead of running without a document. */
export function heldUploadError(res = null) {
  // The message is what a consumer that shows e.message would show: the approved line, or nothing while it is off.
  const e = new Error(UPLOAD_CHECKING_APPROVED ? UPLOAD_CHECKING_COPY : '');
  e.code = UPLOAD_CHECKING_CODE;
  e.quarantineId = heldQuarantineId(res);
  return e;
}

/** Round 3: the held row's id from a 202 answer (the server's quarantineId), or null. */
export function heldQuarantineId(res) {
  if (!res) return null;
  const body = res.data !== undefined ? res.data : res.body;
  const n = Number(body && body.quarantineId);
  return Number.isInteger(n) && n > 0 ? n : null;
}
export const isHeldUploadError = (e) => !!e && e.code === UPLOAD_CHECKING_CODE;
/** What a catch shows for a held upload: the approved line, or nothing while the wording is off (never "did not go through"). */
export const heldUploadMessage = () => (UPLOAD_CHECKING_APPROVED ? UPLOAD_CHECKING_COPY : null);
